<template>
    <div class="body-wrapper">
        <div class="container-fluid">
            <div class="card card-body">
                <div class="row align-items-center">
                    <div class="col-12">
                        <div class="d-sm-flex align-items-center justify-space-between">
                            <h4 class="fw-semibold fs-4 mb-4 mb-md-0 card-title">{{ title ?? "Carregando..." }}</h4>
                            <nav aria-label="breadcrumb" class="ms-auto">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item" aria-current="page">
                                        <router-link to="/clientes" type="submit"
                                            class="btn btn-primary btn-sm hstack gap-6">
                                            <i class="ti ti-arrow-back fs-4"></i>
                                            Voltar para lista
                                        </router-link>
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <h4 class="card-title mb-3">Informações Básicas</h4>

                            <div class="row">
                                <div class="col-md-5">
                                    <div class="form-floating mb-3">
                                        <input v-model="name" type="text" class="form-control"
                                            placeholder="Nome Completo" />
                                        <label for="tb-fname">Nome Completo</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-floating mb-3">
                                        <input v-model="email" type="email" class="form-control" placeholder="E-mail" />
                                        <label for="tb-email">E-mail (Ex.: teste@teste.com)</label>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-floating mb-3">
                                        <input v-model="phone" type="text" class="form-control" placeholder="Telefone"
                                            v-maska="'(##) #####-####'" />
                                        <label for="tb-fname">Telefone</label>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-floating mb-3">
                                        <input v-model="cpf" type="text" class="form-control" placeholder="Telefone"
                                            v-maska="'###.###.###-##'" />
                                        <label for="tb-fname">CPF</label>
                                    </div>
                                </div>
                            </div>

                            <h4 class="card-title mb-3 mt-5">Endereço Principal</h4>
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-floating mb-3">
                                        <input v-model="zip_code" type="text" class="form-control" placeholder="CEP"
                                            v-maska="'#####-###'" @change="searchCEP(0)" />
                                        <label for="tb-fname">CEP</label>
                                    </div>
                                </div>
                                <div class="col-md-7">
                                    <div class="form-floating mb-3">
                                        <input v-model="street" type="email" class="form-control" placeholder="Rua" />
                                        <label for="tb-email">Rua (Ex.: Rua das neves)</label>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-floating mb-3">
                                        <input v-model="street_number" type="text" class="form-control"
                                            placeholder="CEP" />
                                        <label for="tb-fname">Número</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-floating mb-3">
                                        <input v-model="neighbohood" type="email" class="form-control"
                                            placeholder="Bairro" />
                                        <label for="tb-email">Bairro</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-floating mb-3">
                                        <input v-model="city" type="email" class="form-control" placeholder="Cidade" />
                                        <label for="tb-email">Cidade</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-floating mb-3">
                                        <input v-model="state" type="email" class="form-control" placeholder="Estado" />
                                        <label for="tb-email">Estado</label>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-5">
                                <div class="form-floating mb-3">
                                    <input v-model="complement" type="text" class="form-control"
                                        placeholder="Complemento" />
                                    <label for="tb-fname">Complemento</label>
                                </div>
                            </div>

                            <h4 class="card-title mb-3 mt-5">Acesso</h4>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-floating mb-3">
                                        <input v-model="password" type="password" class="form-control"
                                            placeholder="Senha" />
                                        <label for="tb-pwd">Senha</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-floating mb-3">
                                        <input v-model="re_password" type="password" class="form-control"
                                            placeholder="Re-Senha" />
                                        <label for="tb-cpwd">Re-Senha</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-5">
                                <div class="col-12">
                                    <div class="d-md-flex align-items-center">
                                        <div class="ms-auto mt-3 mt-md-0">
                                            <button class="btn btn-primary hstack gap-6" @click="update">
                                                <i class="ti ti-edit fs-4"></i>
                                                Editar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="card card-body">
                        <h4 class="card-title mb-3">Endereços Adicionais</h4>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-floating mb-3">
                                    <input v-model="add_name_address" type="email" class="form-control"
                                        placeholder="Bairro" />
                                    <label for="tb-email">Nome do Endereço</label>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-floating mb-3">
                                    <input v-model="add_resp_address" type="email" class="form-control"
                                        placeholder="Bairro" />
                                    <label for="tb-email">Nome do Responsável</label>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-floating mb-3">
                                    <input v-model="add_zip_code" type="text" class="form-control" placeholder="CEP"
                                        v-maska="'#####-###'" @change="searchCEP(1)" />
                                    <label for="tb-fname">CEP</label>
                                </div>
                            </div>
                            <div class="col-md-7">
                                <div class="form-floating mb-3">
                                    <input v-model="add_street" type="email" class="form-control" placeholder="Rua" />
                                    <label for="tb-email">Rua (Ex.: Rua das neves)</label>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-floating mb-3">
                                    <input v-model="add_street_number" type="text" class="form-control" placeholder="CEP" />
                                    <label for="tb-fname">Número</label>
                                </div>
                            </div>
                            <div class="col-md-3 col-12">
                                <div class="form-floating mb-3">
                                    <input v-model="add_state" type="email" class="form-control" placeholder="Estado" />
                                    <label for="tb-email">Estado</label>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-floating mb-3">
                                    <input v-model="add_neighbohood" type="email" class="form-control"
                                        placeholder="Bairro" />
                                    <label for="tb-email">Bairro</label>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-floating mb-3">
                                    <input v-model="add_city" type="email" class="form-control" placeholder="Cidade" />
                                    <label for="tb-email">Cidade</label>
                                </div>
                            </div>

                            <div class="col-12 mt-2 mb-5">
                                <div class="d-md-flex align-items-center">
                                    <div class="ms-auto mt-3 mt-md-0">
                                        <button type="submit" class="btn btn-primary hstack gap-6" @click="addAddress">
                                            <i class="ti ti-plus fs-4"></i>
                                            Adicionar Endereço
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <table class="table text-nowrap mb-0 align-middle">
                                    <thead class="text-dark fs-4">
                                        <tr>
                                            <th>
                                                <h6 class="fs-4 fw-semibold mb-0">Nome</h6>
                                            </th>
                                            <th>
                                                <h6 class="fs-4 fw-semibold mb-0">Responsável</h6>
                                            </th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="address in addresses" :key="address.id">
                                            <td>
                                                <p class="mb-0 fw-normal"><strong>{{ address.name }}</strong></p>
                                                <p class="mb-0 fw-normal">{{ address.street }}, nº {{ address.street_number }}, {{ address.neighbohood }}, {{ address.city }} - {{ address.state }}</p>
                                            </td>
                                            <td>
                                                <p class="mb-0 fw-normal">{{ address.resp_address }}</p>
                                            </td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

import Cookies from 'js-cookie';
import App from '@/App.vue';

export default {
    mixins: [
        App
    ],
    data() {
        return {
            title: null,
            role: 0,
            name: '',
            email: '',
            phone: '',
            cnpj: '',
            responsible: '',
            cpf: '',
            password: '',
            re_password: '',
            zip_code: '',
            street: '',
            street_number: '',
            neighbohood: '',
            city: '',
            state: '',
            complement: '',
            role_id: 2,
            isSearch: false,
            individual_id: 0,
            address_id: 0,
            item_id: 0,
            add_name_address: '',
            add_resp_address: '',
            add_zip_code: '',
            add_street: '',
            add_street_number: '',
            add_state: '',
            add_neighbohood: '',
            add_city: '',
            addresses: []
        }
    },
    methods: {
        update() {
            const json = {
                address_id: this.address_id,
                individual_id: this.individual_id,
                name: this.name,
                email: this.email,
                phone: this.phone,
                cpf: this.cpf,
                password: this.password,
                re_password: this.re_password,
                zip_code: this.zip_code,
                street: this.street,
                street_number: this.street_number,
                neighbohood: this.neighbohood,
                city: this.city,
                state: this.state,
                complement: this.complement,
                role_id: this.role_id,
            }

            this.$http.put('/users/' + this.item_id, json, {
                headers: {
                    'Authorization': 'Bearer ' + Cookies.get('_token')
                }
            }).then((response) => {
                this.showAlert('success', response.data.message);
                this.load()
            }).catch(error => {
                this.showAlert('error', error.response.data);
            });
        },
        load() {
            this.$http.get('/users/' + this.item_id, {
                headers: {
                    'Authorization': 'Bearer ' + Cookies.get('_token')
                }
            }).then(response => {

                this.name = response.data.item.individual.name || '';
                this.email = response.data.item.email || '';
                this.phone = response.data.item.phone || '';
                this.cnpj = response.data.item.cnpj || '';
                this.responsible = response.data.item.responsible || ''
                this.cpf = response.data.item.individual.cpf || '';
                this.zip_code = response.data.item.individual.addresses[0].zip_code || '';
                this.street = response.data.item.individual.addresses[0].street || '';
                this.street_number = response.data.item.individual.addresses[0].street_number || '';
                this.neighbohood = response.data.item.individual.addresses[0].neighbohood || '';
                this.city = response.data.item.individual.addresses[0].city || '';
                this.state = response.data.item.individual.addresses[0].state || '';
                this.complement = response.data.item.individual.addresses[0].complement || '';

                this.individual_id = response.data.item.individual.id;
                this.address_id = response.data.item.individual.addresses[0].id;

                this.title = 'Cliente - ' + this.name;
                this.isSearch = true;

                this.addresses = response.data.item.individual.addresses || [];

            }).catch(error => {
                this.showAlert('error', error.response.data);
            });
        },
        searchCEP(type) {
            
            if ((!this.zip_code || this.zip_code.length < 9 || !this.isSearch) && type == 0) {
                return;
            }

            if ((!this.add_zip_code || this.add_zip_code.length < 9 || !this.isSearch) && type == 1) {
                return;
            }

            const zip_code = (type == 0)? this.zip_code : this.add_zip_code;

            this.$http.get('/cep/' + zip_code)
                .then((response) => {

                    if(type == 0){
                        this.street = response.data.logradouro;
                        this.neighbohood = response.data.bairro;
                        this.city = response.data.localidade;
                        this.state = response.data.uf;
                        return;
                    }

                    this.add_street = response.data.logradouro;
                    this.add_neighbohood = response.data.bairro;
                    this.add_city = response.data.localidade;
                    this.add_state = response.data.uf;

                }).catch((error) => {
                    if (error.response && error.response.data) {
                        this.showAlert('error', error.response.data);
                    } else {
                        this.showAlert('error', 'Ocorreu um erro desconhecido. Entre em contato com a equipe de desenvolvimento.');
                    }
                })
        },
        addAddress(){
            const json = { 
                name: this.add_name_address,
                resp_address: this.add_resp_address,
                zip_code: this.add_zip_code,
                street: this.add_street,
                street_number: this.add_street_number,
                state: this.add_state,
                neighbohood: this.add_neighbohood,
                city: this.add_city,
                individual_id: this.individual_id
            }

            this.$http.post('/address', json, {
                headers: {
                    'Authorization': 'Bearer ' + Cookies.get('_token')
                }
            }).then((response) => {
                this.showAlert('success', response.data.message);
                this.load()
            }).catch(error => {
                this.showAlert('error', error.response.data);
            });
        }
    },
    created() {
        this.role = this.$store.state.role;
        this.item_id = this.$route.params.id;
        this.load();
    }
}
</script>
